import { render, staticRenderFns } from "./wirewideNetwork.vue?vue&type=template&id=1bb3fe4a&scoped=true&"
import script from "./wirewideNetwork.vue?vue&type=script&lang=js&"
export * from "./wirewideNetwork.vue?vue&type=script&lang=js&"
import style0 from "./particulars.css?vue&type=style&index=0&id=1bb3fe4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb3fe4a",
  null
  
)

export default component.exports